import { Text } from "../ui/text";

export interface ExampleQuestionItem {
  title: string;
}

interface ExampleQuestionItemProps {
  question: ExampleQuestionItem;
  onClick: (index: number) => void;
  index: number;
  selectedQuestionIndex: number;
}

const ExampleQuestionItem = ({
  question,
  onClick,
  index,
  selectedQuestionIndex,
}: ExampleQuestionItemProps) => {
  const isSelected = selectedQuestionIndex === index;

  return (
    <button
      className="
        relative
        overflow-hidden
        rounded-lg
        backdrop-blur-sm
        active:scale-[0.98]
        transition-all 
        duration-200 
        ease-in-out"
      style={{
        boxShadow: "0 4px 10px 0 rgba(55, 55, 55, 0.1)",
      }}
      onClick={() => onClick(index)}
    >
      <div
        className="
          flex
          items-center
          justify-center
          gap-[10px]
          px-4
          py-[10px]
          text-gray-700 
          font-medium 
          text-lg
          transition-colors
          duration-200
        "
        style={{
          background: "rgba(255, 255, 255, 0.50)",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "8px",
          border: "1px solid rgba(255, 255, 255, 0.8)",
        }}
      >
        <Text variant={"body-md"} className="text-grey-20">
          {question.title}
        </Text>
      </div>
    </button>
  );
};

export default ExampleQuestionItem;
